exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-container {\n  position: relative;\n}\n.field-container input[type=text] {\n  background-size: 17px;\n  padding: 0;\n  outline: none;\n}\n.field-container input[type=text]::placeholder {\n  color: var(--color-placeholder);\n  text-transform: var(--text-transform-placeholder);\n  text-align: left;\n}", ""]);

// exports
